// 扁平化的表格数据 flatTableData

// 需要合并的列字段 mergeLines [{field: "applyName", condition: "id"}]
export default {
  computed: {
    rowSpanConfigs() {
      let rowSpanConfigs = {};

      this.mergeLines.forEach(item => {
        rowSpanConfigs[item.field] = this.getMergeCellsConfig(
          item.field,
          item.condition
        );
      });

      return rowSpanConfigs;
    }
  },

  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for (let key in this.rowSpanConfigs) {
        if (column.property === key) {
          const _row = this.rowSpanConfigs[key][rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      }
    },

    getMergeCellsConfig(propSelf, propOther = null) {
      let rowSpanConfig = [];
      let position = 0;

      this.flatTableData.forEach((item, index, obj) => {
        if (!index) return rowSpanConfig.push(1);

        const toggle = this.canMergeCells(
          item,
          obj[index - 1],
          propSelf,
          propOther
        );

        if (toggle) {
          rowSpanConfig[position] += 1;
          rowSpanConfig.push(0);
        } else {
          rowSpanConfig.push(1);
          position = index;
        }
      });

      return rowSpanConfig;
    },

    canMergeCells(curr, prev, propSelf, propOther = null) {
      const selfJudge = curr[propSelf] === prev[propSelf];

      const otherJudge = propOther ? curr[propOther] === prev[propOther] : true;

      return selfJudge && otherJudge;
    }
  }
};
